import { EjournalEntry } from '@escrowtab/v2profile-api-client';

/**
 * Types of notarial acts as defined by the National Notary Association (NNA)
 */
export enum NotarialActType {
  ACKNOWLEDGMENTS = 'Acknowledgments',
  JURATS = 'Jurats',
  OATHS_AFFIRMATIONS = 'Oaths/affirmations',
  COPY_CERTIFICATION = 'Copy certification',
  SIGNATURE_WITNESSING = 'Signature witnessing',
}

/**
 * Coordinates of a stamp on a document page
 */
export interface StampCoordinates {
  left: number;
  top: number;
  width: number;
  height: number;
}

/**
 * Information about an intercepted stamp
 */
export interface StampInfo {
  page: string;
  tab: number;
  signatureId: string;
  stampType: string | undefined;
  stampId: string | undefined;
  coordinates: StampCoordinates;
  signingDateTime: Date;
}

/**
 * Extended eJournal entry with custom fields for stamp-based entries
 */
export interface StampEJournalEntry extends Partial<EjournalEntry> {
  dateOfSigning: string;
  timeOfSigning: string;
  description: string;
  stateOfSigning: string;
  feeForNotarization: number;
  typeOfTechnologyUsed: string;
  technologyPlatform: string;
  typeOfNotorialAct: string;
  notes?: string;
  id?: string;
}

/**
 * Combined stamp information and eJournal entry data.
 * Used for both editing (one per stamp, signers[] may have multiple) and
 * saving (one per signer; see SavedEJournalEntry).
 */
export interface StampWithEJournalEntry {
  stampInfo: StampInfo;
  eJournalEntry: StampEJournalEntry;
}

/**
 * Saved eJournal format: one entry per signer.
 * Each item has the same stamp and metadata but eJournalEntry.signers
 * contains exactly one signer. Emitted when saving from the review UI.
 */
export type SavedEJournalEntry = StampWithEJournalEntry;
